module.exports = __webpack_public_path__ + "img/trailer.8dea5a8d.png";